import { RefObject, useLayoutEffect, useState } from 'react';
import { measureStepAccordionActiveMaxHeight } from 'utils/step-accordion-active-max-height';

export function useStepAccordionActiveMaxHeight(
  listRef: RefObject<HTMLElement | null>,
  activeRef: RefObject<HTMLElement | null>,
  observeKey: string
): number | undefined {
  const [maxHeight, setMaxHeight] = useState<number | undefined>();

  useLayoutEffect(() => {
    const list = listRef.current;
    if (!list) {
      setMaxHeight(undefined);
      return undefined;
    }

    const update = () => {
      setMaxHeight(
        measureStepAccordionActiveMaxHeight(list, activeRef.current)
      );
    };

    update();

    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(update);
    observer.observe(list);
    for (const child of Array.from(list.children)) {
      observer.observe(child);
    }

    return () => observer.disconnect();
  }, [activeRef, listRef, observeKey]);

  return maxHeight;
}
